module.exports = __webpack_public_path__ + "static/media/back-icon.9d0cd5f3.psd";